var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['status-label-wrapper']},[_c('div',{class:( _obj = {}, _obj[_vm.$style.circle] = true, _obj[_vm.$style.is_active] = _vm.status, _obj[_vm.$style.is_inactive] = !_vm.status, _obj )}),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.statusName))])])}
var staticRenderFns = []

export { render, staticRenderFns }